import React from 'react';

export default function AuthDivider({ text = 'ou' }) {
  const lineStyle = { flex: 1, height: 1, background: 'rgba(11,29,53,0.06)' };
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 16, margin: '24px 0', color: 'var(--text-muted)', fontSize: '0.8rem' }}>
      <div style={lineStyle} />
      {text}
      <div style={lineStyle} />
    </div>
  );
}